/**
 * Eot Live Text Logo
 * @copyright 2021-2023 Soter Technologies, LLC. All rights reserved.
 * @file EotLive.js
 * @author Kyle Watkins, Matt Schreider, Paul Scala
 */

import React from 'react'
import '../resources/less/logo.less'

/**
 * Eot live logo component
 * @param {object} props Component props
 * @param {'small'|'medium'} props.size
 */
function EotLive({size = 'small'}) {
    return (
        <div className={`logoOuter ${size}`}>
            <div className='logoBox eot'>
                {(process.env.IsIveda === false || size === 'small') && 
                    <h2 className='eotText'>
                        EoT
                    </h2>}
                {process.env.IsIveda === true && size === 'medium' && 
                    <h2 className='eotText' style={{paddingTop: "8px", fontSize: "28px" /* paddingLeft: "10px", fontSize: "40px"*/}}>
                        IvedaAI&#8482; Sense
                    </h2>}
            </div>
            <div className='logoBox live'>
                {(process.env.IsIveda === false || size === 'small') &&
                    <div className='liveText'>
                        LIVE
                    </div>}
                {process.env.IsIveda === true && size === 'medium' && 
                    <div className='liveText' style={{paddingRight: "2px", paddingTop: "2px", fontSize: "26px"}}>
                        EoT LIVE
                    </div>} 
            </div>
        </div>
    )
}

export default EotLive